export const COLORS = [
  '#7C62FF',
  '#FF3636',
  '#27AE60',
  '#FF7E36',
  '#2C87FD',
  '#F4D800',
  '#232323',
];
